/* eslint-disable react/jsx-child-element-spacing */
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { message as toaster } from 'antd';
// import moment from 'moment';
import { Box, Image, Text, Flex } from 'atoms';
import goBack from 'assets/go-back.svg';
import RefreshIcon from 'assets/refresh.svg';
import denomination from 'assets/denomination.svg';
import CloseArrow from 'assets/icons/close-arrow.svg';
import { setShowLogout } from 'store/appSlice';
import {
	// MakeAllBillBack,
	ClearConfirmation,
	RejectionNotificationPusher,
} from 'components/pages/collection';
import { getSalesInvoicesList } from 'store/salesmanSlice';
import { useQueryParams } from 'hooks';
import { AR } from 'utils/constants';
import { setselectedSalesMan } from 'store/userSlice';
import Denominations from 'components/pages/collection-app/denomination/Denominations';
import DetailedModal from './DetailedModal';
import MakeAllBillBack from 'components/pages/collection-app/MakeAllBillBack';

const ShowDetailsWrapper = styled.div`
	width: 95px;
	height: 44px;
	border-radius: 50%;
	background: #fff;
	text-align: center;
	position: fixed;
	top: 0;
	z-index: 1;
	margin-top: -22px;
	left: 50%;
	cursor: pointer;
	transform: translateX(-50%);
`;

const ShowDetailsArrow = styled(Flex)`
	width: 95px;
	height: 22px;
	margin-top: 22px;
`;

export default function SalesmanHeader({ isPending }) {
	const [isDenominationVisible, setDenominationVisible] = useState(false);
	const [isAnyPending, setIsAnyPending] = useState(false);
	const [showDetailView, setShowDetailView] = useState(false);

	const [showAllBillBackModal, setShowAllBillBackModal] = useState(false);
	const [showGoBackConfirmation, setShowGoBackConfirmation] = useState(false);
	const { me = {}, selectedSalesMan = {} } = useSelector((state) => state.user);
	// const { invoiceDate } = useSelector((state) => state.app);
	const {
		SalesInvoices = [],
		SalesRejectedInvoices = [],
		isInvoiceOpen = false,
		isAccordionOpen,
	} = useSelector((state) => state.salesman);

	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();
	const { salesmanId = undefined } = useQueryParams();

	useEffect(() => {
		// let pendingStatus = false;

		/**
		 *  If there is any "Pending" status in receivedInvoiceList and newInvoices
		 *  If "yes" pendingStatus will assigned as true
		 * */

		// denomination
		console.log(SalesInvoices);
		if (SalesInvoices?.some((item) => item?.status === 'Pending')) {
			setIsAnyPending(true);
		}
	}, [SalesInvoices, location]);

	function goToSalesMenListPage() {
		dispatch(setselectedSalesMan({}));
		setTimeout(() => {
			history.push('salesmenlist');
		}, 1000);
	}

	const showModal = () => {
		if (isInvoiceOpen) {
			toaster.error('Please close the invoice');
		} else if (me?.type === AR) {
			goToSalesMenListPage();
		} else if (isAnyPending) {
			/**
			 * In Additional Resource login, if they click back it will go back to sales men list page
			 */
			setShowAllBillBackModal(true);
		} else {
			setShowDetailView(false);
			dispatch(setShowLogout(true));
		}
	};

	const checkAccordionStatus = () => {
		/**
		 * If selected date is not today date means, on clicking on logout first the date will be changed to today date
		 */
		// else if (invoiceDate !== TODAY) {
		// 	dispatch(setinvoiceDate(TODAY));
		// }

		console.log('checkAccordionStatus');
		if (location?.pathname === '/outlet') {
			setShowGoBackConfirmation(true);
		} else if (me?.type === AR) {
			goToSalesMenListPage();
		} else if (!isAccordionOpen && isInvoiceOpen && isAnyPending) {
			/**
			 * If any invoice is still in pending state, before logout it will ask to force bill back
			 */
			setShowAllBillBackModal(true);
		} else {
			showModal();
		}
	};

	function showDenomination() {
		setDenominationVisible(true);
	}

	function hideDenomination() {
		setDenominationVisible(false);
	}

	function showDetailedView1() {
		setShowDetailView(true);
	}

	const hideDetailedView = () => {
		setShowDetailView(false);
	};

	function getLatestInvoices() {
		console.log('getSalesInvoicesList');

		dispatch(getSalesInvoicesList(salesmanId));
	}

	function handleRedirect() {
		if (me.type === AR) {
			history.push(`/invoices-collection?salesmanId=${selectedSalesMan?.id}`);
		} else {
			history.push('/invoices-collection');
		}
	}

	return (
		<>
			{/* <div style={{ width: '100%', position: 'relative' }}>
				<div
					style={{
						position: 'absolute',
						top: '8px',
						left: '-43px',
						zIndex: '1',
						background: '#e89292',
						padding: '3px 90px',
						transform: 'rotate(-50deg)',
					}}
				>
					{' '}
				</div>
			</div> */}
			{SalesInvoices?.length > 0 &&
				!isAnyPending &&
				!showDetailView &&
				location?.pathname !== '/outlet' && (
					<ShowDetailsWrapper onClick={showDetailedView1}>
						<ShowDetailsArrow
							alignItems="center"
							flexDirection="column"
							justifyContent="center"
						>
							<Image src={CloseArrow} alt="Down Arrow" width={17} />
						</ShowDetailsArrow>
					</ShowDetailsWrapper>
				)}
			{/* {SalesInvoices.length === 0 && SalesRejectedInvoices?.length > 0 && (
				<ShowDetailsWrapper onClick={showDetailedView1}>
					<ShowDetailsArrow
						alignItems="center"
						flexDirection="column"
						justifyContent="center"
					>
						<Image src={CloseArrow} alt="Down Arrow" width={17} />
					</ShowDetailsArrow>
				</ShowDetailsWrapper>
			)} */}
			{SalesInvoices.length === 0 && SalesRejectedInvoices?.length > 0 && (
				<ShowDetailsWrapper onClick={showDetailedView1}>
					<ShowDetailsArrow
						alignItems="center"
						flexDirection="column"
						justifyContent="center"
					>
						<Image src={CloseArrow} alt="Down Arrow" width={17} />
					</ShowDetailsArrow>
				</ShowDetailsWrapper>
			)}

			<MakeAllBillBack
				isPending={isPending}
				visible={showAllBillBackModal}
				hide={() => setShowAllBillBackModal(false)}
			/>
			<Flex
				justifyContent="space-around"
				alignItems="center"
				height="44px"
				bg="#0168D0"
				color="#fff"
			>
				<Box cursor="pointer" onClick={checkAccordionStatus}>
					<Image src={goBack} alt="Logout" height={12} width={12} />
				</Box>
				<Text fontSize="12px" style={{ zIndex: '3', position: 'relative' }}>
					Collection Page
					<span
						style={{
							position: 'absolute',
							top: '-9px',
							right: '-26px',
							fontSize: '9px',
							background: '#fff',
							color: 'red',
							padding: '2px',
							borderRadius: '3px',
						}}
					>
						New{' '}
					</span>
				</Text>
				<Flex justifyContent="flex-end" alignItems="center" width="60%">
					<Box
						cursor="pointer"
						mx="12px"
						onClick={getLatestInvoices}
						pr={location?.pathname === '/outlet' ? '45%' : '0'}
					>
						<Image src={RefreshIcon} alt="RefreshIcon" height={24} width={24} />
					</Box>
					{location?.pathname !== '/outlet' && (
						<RejectionNotificationPusher getLatestInvoices={getLatestInvoices} />
					)}
					{SalesInvoices?.length > 0 &&
						!isAnyPending &&
						location?.pathname !== '/outlet' && (
							<Box cursor="pointer" mx="12px" onClick={showDenomination} mt="5px">
								<Image
									src={denomination}
									alt="Denomination"
									height={19}
									width={26}
								/>
							</Box>
						)}
					{SalesInvoices?.length === 0 &&
						SalesRejectedInvoices?.length > 0 &&
						!isAnyPending &&
						location?.pathname !== '/outlet' && (
							<Box cursor="pointer" mx="12px" onClick={showDenomination} mt="5px">
								<Image
									src={denomination}
									alt="Denomination"
									height={19}
									width={26}
								/>
							</Box>
						)}
				</Flex>
			</Flex>
			{/* {SalesInvoices.length === 0 && SalesRejectedInvoices?.length > 0 && (
				<Denominations onClose={hideDenomination} detailView={showDetailedView1} />
			)} */}
			{isDenominationVisible && (
				<Denominations onClose={hideDenomination} detailView={showDetailedView1} />
			)}

			{/* Summary modal */}
			{showDetailView && (
				<DetailedModal
					width={455}
					showModal={showModal}
					visible={showDetailView}
					hideDetailedView={hideDetailedView}
				/>
			)}

			{/* <DetailedModal
				width={455}
				showModal={showModal}
				visible={showDetailView}
				hideDetailedView={hideDetailedView}
			/> */}

			<ClearConfirmation
				visible={showGoBackConfirmation}
				onClose={() => setShowGoBackConfirmation(false)}
				onClear={handleRedirect}
				infoText="Are you sure want to go back to collections, this will clear the entered values"
				yesText="Yes"
			/>
		</>
	);
}

SalesmanHeader.propTypes = {
	isPending: PropTypes.bool,
};
